export default function scrollTo(name) {
  const element = document.getElementById(name);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}
